import { Component } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-error',
  templateUrl: './timedout.component.html',
})
export class SesssionTimedComponent {
    end = false;
    version: string = '5.0.0';
  constructor(
    private router: Router,
    private ar: ActivatedRoute,
  ) {
      this.end = window.location.href.includes('sesssionEnded')
      this.version = environment.version;
  }

  login() {
    this.router.navigate(['login'])
  }
}
